import { createMap, extend, forMember, mapFrom, mapWith } from "@automapper/core";
import { BaseModel } from "../base/base.model";
import { AutoMap } from "@automapper/classes";
import { mapper } from "src/app/infrastructure/infrastructure-services/common/mapper";
import { CommonEnumData, CommonFilterModel } from "src/app/infrastructure/infrastructure-services/common/models/wrapper.model";
import { PaymentChecks, PaymentChecksSAP, PaymentCreditCards, PaymentCreditCardsSAP } from "./payment-means.model";

export interface IIncomingPaymentModel extends BaseModel {

    Attachments2_Lines: IAttachments2_LinesModel[];
    attachmentEntry: string | null;
    document: string;
    locked: string;
    cardCode: string;
    cardName: string;
    payToCode: string;
    address: string;
    contactPersonCode: number;
    contactPersonName: string;
    series: number;
    seriesName: string;
    docEntry: number;
    docNum: number;
    docType: string;
    docTypeName: string;
    docDate: string | Date;
    docDueDate: string | Date;
    transactionNo: number;
    bplid: number;
    branchName: string;
    vatRegNum: string;
    remarks: string;
    journalRemarks: string;
    controlAccount: string;
    controlAccountName: string;
    totalAmount: number;
    paymentOnAccoount: string;
    paymentOnAccoountBalance: number;
    paymentOnAccoountBalanceFC: number;
    paymentOnAccoountBalanceSys: number;
    openBalance: number;
    cashAccount: string;
    cashAccountName: string;
    cashSum: number;
    creditSum: number;
    checkSum: number;
    docCurrency: string;
    docCurrencyName: string;
    checkAccount: string;
    transferAccount: string;
    transferSum: number;
    transferSumFC: number;
    transferAccountName: string;
    transferDate: string;
    transferReference: string;
    splitTransaction: string;
    bankChargeAmount: number;
    bankChargeAmountFC: number;
    docTotal: number;
    cancelled: string;
    taxDate: string | Date;
    cancelledDate: string;
    counterReference: string;
    discountPercent: number;
    totalDiscount: number;
    totalDiscountFC: number;
    cashSumFC: number;
    checkSumFC: number;
    creditSumFC: number;
    docTotalFC: number;
    paymentChecks: PaymentChecks[
    ],
    paymentInvoices: PaymentInvoices[

    ],
    paymentCreditCards: PaymentCreditCards[

    ]
    billToCode: string;
    paymentAccounts: PaymentAccounts[];
    isViewMode:boolean;


}





export class IncomingPaymentModel implements IIncomingPaymentModel {

    @AutoMap(() => Attachments2_LinesModel)
    Attachments2_Lines: Attachments2_LinesModel[] = [];
    @AutoMap() attachmentEntry: string | null = null;
    @AutoMap() document: string = "";
    @AutoMap() locked: string = "";
        @AutoMap()       isViewMode:boolean=false;;
    @AutoMap() cardCode: string = "";
    @AutoMap() cardName: string = "";
    @AutoMap() payToCode: string = "";
    @AutoMap() address: string = "";
    @AutoMap() contactPersonCode: number = 0;
    @AutoMap() contactPersonName: string = "";
    @AutoMap() series: number = 0;
    @AutoMap() seriesName: string = "";
    @AutoMap() docEntry: number = 0;
    @AutoMap() docNum: number = 0;
    @AutoMap() docType: string = "";
    @AutoMap() docTypeName: string = "";
    @AutoMap() docDate: string | Date= "";
    @AutoMap() docDueDate: string | Date = "";
    @AutoMap() transactionNo: number = 0;
    @AutoMap() bplid: number = 0;
    @AutoMap() branchName: string = "";
    @AutoMap() vatRegNum: string = "";
    @AutoMap() remarks: string = "";
    @AutoMap() journalRemarks: string = "";
    @AutoMap() controlAccount: string = "";
    @AutoMap() controlAccountName: string = "";
    @AutoMap() totalAmount: number = 0;
    @AutoMap() paymentOnAccoount: string = "";
    @AutoMap() paymentOnAccoountBalance: number = 0;
    @AutoMap() paymentOnAccoountBalanceFC: number = 0;
    @AutoMap() paymentOnAccoountBalanceSys: number = 0;
    @AutoMap() openBalance: number = 0;
    @AutoMap() cashAccount: string = "";
    @AutoMap() cashAccountName: string = "";
    @AutoMap() cashSum: number = 0;
    @AutoMap() creditSum: number = 0;
    @AutoMap() checkSum: number = 0;
    @AutoMap() docCurrency: string = "";
    @AutoMap() docCurrencyName: string = "";
    @AutoMap() checkAccount: string = "";
    @AutoMap() transferAccount: string = "";
    @AutoMap() transferSum: number = 0;
    @AutoMap() transferSumFC: number = 0;
    @AutoMap() transferAccountName: string = "";
    @AutoMap() transferDate: string = "";
    @AutoMap() transferReference: string = "";
    @AutoMap() splitTransaction: string = "";
    @AutoMap() bankChargeAmount: number = 0;
    @AutoMap() bankChargeAmountFC: number = 0;
    @AutoMap() docTotal: number = 0;
    @AutoMap() cancelled: string = "";
    @AutoMap() taxDate: string | Date = "";
    @AutoMap() cancelledDate: string = "";
    @AutoMap() counterReference: string = "";
    @AutoMap() discountPercent: number = 0;
    @AutoMap() totalDiscount: number = 0;
    @AutoMap() totalDiscountFC: number = 0;
    @AutoMap() cashSumFC: number = 0;
    @AutoMap() checkSumFC: number = 0;
    @AutoMap() creditSumFC: number = 0;
    @AutoMap() docTotalFC: number = 0;
    @AutoMap(() => PaymentChecks) paymentChecks: PaymentChecks[] = [];
    @AutoMap() paymentInvoices: PaymentInvoices[] = [];
    @AutoMap(() => PaymentCreditCards) paymentCreditCards: PaymentCreditCards[] = [];
    @AutoMap(() => PaymentAccounts) paymentAccounts: PaymentAccounts[] = [];
    @AutoMap() billToCode: string = "";
    constructor() {
        createMap(mapper, IncomingPaymentModel, IncomingPaymentModelSAP,
            forMember(
                (destination) => (destination.AttachmentEntry),
                mapFrom((source) => (source.attachmentEntry))
            ),
            forMember(
                (destination) => (destination.CardCode),
                mapFrom((source) => (source.cardCode))
            ),
            forMember(
                (destination) => (destination.CardName),
                mapFrom((source) => (source.cardName))
            ),
            forMember(
                (destination) => (destination.PayToCode),
                mapFrom((source) => (source.payToCode))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            // forMember(
            //     (destination) => (destination.ContactPersonCode),
            //     mapFrom((source) => (source.contactPersonCode))
            // ),
            forMember(
                (destination) => (destination.Series),
                mapFrom((source) => (source.series))
            ),
            forMember(
                (destination) => (destination.DocEntry),
                mapFrom((source) => (source.docEntry))
            ),
            forMember(
                (destination) => (destination.DocNum),
                mapFrom((source) => (source.docNum))
            ),
            forMember(
                (destination) => (destination.DocType),
                mapFrom((source) => (source.docType))
            ),
            forMember(
                (destination) => (destination.DocDate),
                mapFrom((source) => (source.docDate))
            ),
            forMember(
                (destination) => (destination.DueDate),
                mapFrom((source) => (source.docDueDate))
            ),
            forMember(
                (destination) => (destination.TaxDate),
                mapFrom((source) => (source.taxDate))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            forMember(
                (destination) => (destination.BPLID),
                mapFrom((source) => (source.bplid))
            ),
            forMember(
                (destination) => (destination.BPLName),
                mapFrom((source) => (source.branchName))
            ),
            forMember(
                (destination) => (destination.Remarks),
                mapFrom((source) => (source.remarks))
            ),
            forMember(
                (destination) => (destination.JournalRemarks),
                mapFrom((source) => (source.journalRemarks))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            // forMember(
            //     (destination) => (destination.DocTotal),
            //     mapFrom((source) => (source.docTotal))
            // ),

            forMember(
                (destination) => destination.PaymentInvoices,
                mapWith(PaymentInvoicesSAP, PaymentInvoices, (source) => source.paymentInvoices)
            ),
            forMember(
                (destination) => destination.PaymentChecks,
                mapWith(PaymentChecksSAP, PaymentChecks, (source) => source.paymentChecks)
            ),
            forMember(
                (destination) => destination.PaymentCreditCards,
                mapWith(PaymentCreditCardsSAP, PaymentCreditCards, (source) => source.paymentCreditCards)
            ),
            forMember(
                (destination) => destination.PaymentAccounts,
                mapWith(PaymentAccountsSAP, PaymentAccounts, (source) => source.paymentAccounts)
            ),
            forMember(
                (destination) => (destination.CashAccount),
                mapFrom((source) => (source.cashAccount))
            ),
            // forMember(
            //     (destination) => (destination.CashAccountName),
            //     mapFrom((source) => (source.cashAccountName))
            // ),
            forMember(
                (destination) => (destination.CashSum),
                mapFrom((source) => (source.cashSum))
            ),
            forMember(
                (destination) => (destination.TransferSum),
                mapFrom((source) => (source.transferSum))
            ),
            // forMember(
            //     (destination) => (destination.CheckSum),
            //     mapFrom((source) => (source.checkSum))
            // ),
            forMember(
                (destination) => (destination.TransferAccount),
                mapFrom((source) => (source.transferAccount))
            ),
            // forMember(
            //     (destination) => (destination.TransferAccountName),
            //     mapFrom((source) => (source.transferAccountName))
            // ),
            forMember(
                (destination) => (destination.TransferDate),
                mapFrom((source) => (source.transferDate))
            ), forMember(
                (destination) => (destination.TransferReference),
                mapFrom((source) => (source.transferReference))
            ),

        );
    }

}


export interface IIncomingPaymentModelSAP extends BaseModel {

    AttachmentEntry: string | null;
    BPLID: number;
    BPLName: string;
    Series: number;
    DocNum: number;
    CardCode: string;
    CardName: string;
    DocEntry: number;
    Address: string;
    ContactPersonCode: string;
    PayToCode: string;
    DocType: string;
    DocDate: string;
    DueDate: string;
    TaxDate: string;
    CounterReference: string;
    Remarks: string;
    JournalRemarks: string;
    PaymentChecks: PaymentChecksSAP[];
    PaymentInvoices: PaymentInvoicesSAP[];
    PaymentCreditCards: PaymentCreditCardsSAP[];
    PaymentAccounts: PaymentAccountsSAP[];
    // DocTotal: number;
    CashAccount: string;
    // CashAccountName: string;
    CashSum: number;
    // CreditSum: number;
    // CheckSum: number;
    TransferAccount: string;
    TransferSum: number;
    // TransferSumFC: number;
    // TransferAccountName: string;
    TransferDate: string;
    TransferReference: string;
    ControlAccount: string;
    // ControlAccountName:string;
}


export class IncomingPaymentModelSAP implements IIncomingPaymentModelSAP {
    @AutoMap() BPLID: number = 0;;
    @AutoMap() BPLName: string = "";
    @AutoMap() Series: number = 0;
    @AutoMap() DocNum: number = 0;
    @AutoMap() CardCode: string = "";
    @AutoMap() CardName: string = "";
    @AutoMap() DocEntry: number = 0;
    @AutoMap() Address: string = "";
    @AutoMap() ContactPersonCode: string = "";
    @AutoMap() PayToCode: string = "";
    @AutoMap() DocType: string = "";
    @AutoMap() DocDate: string = "";
    @AutoMap() DueDate: string = "";
    @AutoMap() TaxDate: string = "";
    @AutoMap() CounterReference: string = "";
    @AutoMap() Remarks: string = "";
    @AutoMap() JournalRemarks: string = "";
    @AutoMap() ControlAccount: string = "";
    //    @AutoMap() ControlAccountName:string="";
    // @AutoMap() DocTotal: number = 0;
    @AutoMap() AttachmentEntry: string | null = "";
    @AutoMap(() => PaymentChecksSAP) PaymentChecks: PaymentChecksSAP[] = [];
    @AutoMap() PaymentInvoices: PaymentInvoicesSAP[] = [];
    @AutoMap(() => PaymentCreditCardsSAP) PaymentCreditCards: PaymentCreditCardsSAP[] = [];
    @AutoMap() PaymentAccounts: PaymentAccountsSAP[] = [];
    @AutoMap() CashAccount: string = "";
    // @AutoMap() CashAccountName: string="";
    @AutoMap() CashSum: number = 0;
    // @AutoMap() CreditSum: number=0;
    // @AutoMap() CheckSum: number=0;
    @AutoMap() TransferAccount: string = "";
    @AutoMap() TransferSum: number = 0;
    // @AutoMap() TransferSumFC: number=0;
    // @AutoMap() TransferAccountName: string="";
    @AutoMap() TransferDate: string = "";
    @AutoMap() TransferReference: string = "";

    constructor() {
        createMap(mapper, IncomingPaymentModel, IncomingPaymentModelSAP,
            forMember(
                (destination) => (destination.CashAccount),
                mapFrom((source) => (source.cashAccount))
            ),
            // forMember(
            //     (destination) => (destination.CashAccountName),
            //     mapFrom((source) => (source.cashAccountName))
            // ),
            forMember(
                (destination) => (destination.CashSum),
                mapFrom((source) => (source.cashSum))
            ),
            // forMember(
            //     (destination) => (destination.CreditSum),
            //     mapFrom((source) => (source.creditSum))
            // ),
            forMember(
                (destination) => (destination.TransferSum),
                mapFrom((source) => (source.transferSum))
            ),
            // forMember(
            //     (destination) => (destination.CheckSum),
            //     mapFrom((source) => (source.checkSum))
            // ),
            forMember(
                (destination) => (destination.TransferAccount),
                mapFrom((source) => (source.transferAccount))
            ),
            // forMember(
            //     (destination) => (destination.TransferAccountName),
            //     mapFrom((source) => (source.transferAccountName))
            // ),
            forMember(
                (destination) => (destination.TransferDate),
                mapFrom((source) => (source.transferDate))
            ), forMember(
                (destination) => (destination.TransferReference),
                mapFrom((source) => (source.transferReference))
            ),

            forMember(
                (destination) => (destination.AttachmentEntry),
                mapFrom((source) => (source.attachmentEntry))
            ),
            forMember(
                (destination) => (destination.CardCode),
                mapFrom((source) => (source.cardCode))
            ),
            forMember(
                (destination) => (destination.CardName),
                mapFrom((source) => (source.cardName))
            ),
            forMember(
                (destination) => (destination.PayToCode),
                mapFrom((source) => (source.payToCode))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            // forMember(
            //     (destination) => (destination.ContactPersonCode),
            //     mapFrom((source) => (source.contactPersonCode))
            // ),
            forMember(
                (destination) => (destination.Series),
                mapFrom((source) => (source.series))
            ),
            forMember(
                (destination) => (destination.DocEntry),
                mapFrom((source) => (source.docEntry))
            ),
            forMember(
                (destination) => (destination.DocNum),
                mapFrom((source) => (source.docNum))
            ),
            forMember(
                (destination) => (destination.DocType),
                mapFrom((source) => (source.docType))
            ),
            forMember(
                (destination) => (destination.DocDate),
                mapFrom((source) => (source.docDate))
            ),
            forMember(
                (destination) => (destination.DueDate),
                mapFrom((source) => (source.docDueDate))
            ),
            forMember(
                (destination) => (destination.TaxDate),
                mapFrom((source) => (source.taxDate))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            forMember(
                (destination) => (destination.BPLID),
                mapFrom((source) => (source.bplid))
            ),
            forMember(
                (destination) => (destination.BPLName),
                mapFrom((source) => (source.branchName))
            ),
            forMember(
                (destination) => (destination.Remarks),
                mapFrom((source) => (source.remarks))
            ),
            forMember(
                (destination) => (destination.JournalRemarks),
                mapFrom((source) => (source.journalRemarks))
            ),
            forMember(
                (destination) => (destination.Address),
                mapFrom((source) => (source.address))
            ),
            // forMember(
            //     (destination) => (destination.DocTotal),
            //     mapFrom((source) => (source.docTotal))
            // ),
            forMember(
                (destination) => (destination.ControlAccount),
                mapFrom((source) => (source.controlAccount))
            ),
            // forMember(
            //     (destination) => (destination.ControlAccountName),
            //     mapFrom((source) => (source.controlAccountName))
            // ),
            forMember(
                (destination) => destination.PaymentInvoices,
                mapWith(PaymentInvoicesSAP, PaymentInvoices, (source) => source.paymentInvoices)
            ),
            forMember(
                (destination) => destination.PaymentChecks,
                mapWith(PaymentChecksSAP, PaymentChecks, (source) => source.paymentChecks)
            ),
            forMember(
                (destination) => destination.PaymentCreditCards,
                mapWith(PaymentCreditCardsSAP, PaymentCreditCards, (source) => source.paymentCreditCards)
            ),


        );
    }


}

export class PaymentAccounts {
    isSelected: boolean = false;
    sumPaid: number = 0;
    accountCode: string = "";
    accountName: string = "";
    grossAmount: string = "";
    locationCode: string = "";
    locationName: string = "";
    branchName: string = "";
    constructor() {
        createMap(mapper, PaymentAccounts, PaymentAccountsSAP,
            forMember(
                (destination) => (destination.SumPaid),
                mapFrom((source) => (source.sumPaid))
            ),
            forMember(
                (destination) => (destination.AccountCode),
                mapFrom((source) => (source.accountCode))
            ),
            forMember(
                (destination) => (destination.AccountName),
                mapFrom((source) => (source.accountName))
            ),
            forMember(
                (destination) => (destination.GrossAmount),
                mapFrom((source) => (source.grossAmount))
            ),
            forMember(
                (destination) => (destination.LocationCode),
                mapFrom((source) => (source.locationCode))
            ),
            // forMember(
            //     (destination) => (destination.BranchName),
            //     mapFrom((source) => (source.branchName))
            // ),


        )
    }
}
export class PaymentAccountsSAP {
    SumPaid: number = 0;
    AccountCode: string = "";
    AccountName: string = "";
    GrossAmount: string = "";
    LocationCode: string = "";
    // BranchName:string="";
    constructor() {
        createMap(mapper, PaymentAccounts, PaymentAccountsSAP,
            forMember(
                (destination) => (destination.SumPaid),
                mapFrom((source) => (source.sumPaid))
            ),
            forMember(
                (destination) => (destination.AccountCode),
                mapFrom((source) => (source.accountCode))
            ),
            forMember(
                (destination) => (destination.AccountName),
                mapFrom((source) => (source.accountName))
            ),
            forMember(
                (destination) => (destination.GrossAmount),
                mapFrom((source) => (source.grossAmount))
            ),
            forMember(
                (destination) => (destination.LocationCode),
                mapFrom((source) => (source.locationCode))
            ),
            // forMember(
            //     (destination) => (destination.BranchName),
            //     mapFrom((source) => (source.branchName))
            // )
        )
    }
}
export class PaymentInvoices {
    isSelected = false;
    docEntry: number = 0;
    docNum: number = 0;
    sumApplied: number = 0;
    numAtCard:string="";
    docRate: number = 0;
    docLine: number = 0;
    invoiceType: string = "";
    discountPercent: number = 0;
    installmentId: number = 0;
    totalDiscount: number = 0;
    docDate: string | null = "";
    docType: string = "";
    docTypeName : string ="";
    docTotal: number = 0;
    dueAmount: number = 0;
    branchName: string = "";
    dueDate: string | null = "";
    cardCode: string = "";
    docCurrency: string = "";
    overDueDays: number = 0;
    remarks:string="";
    constructor() {
        createMap(mapper, PaymentInvoices, PaymentInvoicesSAP,
            forMember(
                (destination) => (destination.DocEntry),
                mapFrom((source) => (source.docEntry))
            ),
            forMember(
                (destination) => (destination.DocNum),
                mapFrom((source) => (source.docNum))
            ),
            forMember(
                (destination) => (destination.SumApplied),
                mapFrom((source) => (source.sumApplied))
            ),
            forMember(
                (destination) => (destination.DocRate),
                mapFrom((source) => (source.docRate))
            ),
            forMember(
                (destination) => (destination.DocLine),
                mapFrom((source) => (source.docLine))
            ),
            forMember(
                (destination) => (destination.InvoiceType),
                mapFrom((source) => (source.invoiceType))
            ),
            forMember(
                (destination) => (destination.DiscountPercent),
                mapFrom((source) => (source.discountPercent))
            ),
            forMember(
                (destination) => (destination.InstallmentId),
                mapFrom((source) => (source.installmentId))
            ),
            forMember(
                (destination) => (destination.TotalDiscount),
                mapFrom((source) => (source.totalDiscount))
            ),
            // forMember(
            //     (destination) => (destination.DocDate),
            //     mapFrom((source) => (source.docDate))
            // ),
            // forMember(
            //     (destination) => (destination.DocType),
            //     mapFrom((source) => (source.docType))
            // ),
            // forMember(
            //     (destination) => (destination.DocTotal),
            //     mapFrom((source) => (source.docTotal))
            // ),
            //  forMember(
            //     (destination) => (destination.DueAmount),
            //     mapFrom((source) => (source.dueAmount))
            // ),
            // forMember(
            //     (destination) => (destination.BranchName),
            //     mapFrom((source) => (source.branchName))
            // ),
            // forMember(
            //     (destination) => (destination.DueDate),
            //     mapFrom((source) => (source.dueDate))
            // ),
            // forMember(
            //     (destination) => (destination.CardCode),
            //     mapFrom((source) => (source.cardCode))
            // )





        )
    }
}
export class PaymentInvoicesSAP {

    DocEntry: number = 0;
    DocNum: number = 0;
    SumApplied: number = 0;
    DocRate: number = 0;
    DocLine: number = 0;
     InvoiceType: string = "";
    DiscountPercent: number = 0;
    InstallmentId: number = 0;
    TotalDiscount: number = 0;
    // DocDate: string = "";
    //  DocType: string = "";
    //DocTotal: number = 0;
    // DueAmount: number = 0;
    // BranchName: string = "";
    //    DueDate: string = "";
    // CardCode: string = "";
    constructor() {
        createMap(mapper, PaymentInvoices, PaymentInvoicesSAP,
            forMember(
                (destination) => (destination.DocEntry),
                mapFrom((source) => (source.docEntry))
            ),
            forMember(
                (destination) => (destination.DocNum),
                mapFrom((source) => (source.docNum))
            ),
            forMember(
                (destination) => (destination.SumApplied),
                mapFrom((source) => (source.sumApplied))
            ),
            forMember(
                (destination) => (destination.DocRate),
                mapFrom((source) => (source.docRate))
            ),
            forMember(
                (destination) => (destination.DocLine),
                mapFrom((source) => (source.docLine))
            ),
            forMember(
                (destination) => (destination.InvoiceType),
                mapFrom((source) => (source.invoiceType))
            ),
            forMember(
                (destination) => (destination.DiscountPercent),
                mapFrom((source) => (source.discountPercent))
            ),
            forMember(
                (destination) => (destination.InstallmentId),
                mapFrom((source) => (source.installmentId))
            ),
            forMember(
                (destination) => (destination.TotalDiscount),
                mapFrom((source) => (source.totalDiscount))
            ),
            // forMember(
            //     (destination) => (destination.DocDate),
            //     mapFrom((source) => (source.docDate))
            // ),
            // forMember(
            //     (destination) => (destination.DocType),
            //     mapFrom((source) => (source.docType))
            // ),
            // forMember(
            //     (destination) => (destination.DocTotal),
            //     mapFrom((source) => (source.docTotal))
            // ),
            //  forMember(
            //     (destination) => (destination.DueAmount),
            //     mapFrom((source) => (source.dueAmount))
            // ),
            // forMember(
            //     (destination) => (destination.BranchName),
            //     mapFrom((source) => (source.branchName))
            // ),
            // forMember(
            //     (destination) => (destination.DueDate),
            //     mapFrom((source) => (source.dueDate))
            // ),
            // forMember(
            //     (destination) => (destination.CardCode),
            //     mapFrom((source) => (source.cardCode))
            // )






        )
    }

}


export interface IAllEnumData {
    //  singleCounterType: CommonFilterModel[];
    documentStatus: CommonFilterModel[];
    priceSource: CommonFilterModel[];
}

export class AllEnumdata extends CommonEnumData implements IAllEnumData {
    //  @AutoMap() singleCounterType: CommonFilterModel[] = [];
    @AutoMap() documentStatus: CommonFilterModel[] = [];
    @AutoMap() priceSource: CommonFilterModel[] = [];

}
export interface IAttachments2_LinesModel {
    AbsoluteEntry: number,
    LineNum: number,
    SourcePath: string
    FileName: string
    FileExtension: string
    AttachmentDate: string
}
export class Attachments2_LinesModel implements IAttachments2_LinesModel {
    AbsoluteEntry!: number
    LineNum!: number
    SourcePath: string = ""
    FileName: string = ""
    FileExtension: string = ""
    AttachmentDate: string = ""
}
